function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer5",
  transform: "matrix(4.45506,0,0,6.38733,-5.06482e-13,0.138489)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.233,186.557L4.756,3.967L185.537,3.863L187.776,79.466L202.508,98.241L186.715,118.426L186.2,136.365L129.085,137.124L186.267,174.634L186.138,186.949L5.233,186.557Z",
  fill: "currentColor"
}));

var SvgUsericonColor = function SvgUsericonColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 208 192",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.224464,0,0,0.15656,1.13687e-13,-0.0216818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1668,
    height: 2388,
    style: {
      fill: "none"
    }
  }), _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Layer6",
    transform: "matrix(4.45506,0,0,6.38733,-5.06482e-13,0.138489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.355,187.351L186.007,174.673L130.461,138.336L186.694,136.815L187.671,116.911L201.8,100.627L186.496,77.102L185.472,4.213L187.775,-19.608L249.234,-15.893L241.902,215.37L187.671,212.046L186.355,187.351Z",
    style: {
      fill: "rgb(201,231,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer7",
    transform: "matrix(4.45506,0,0,6.38733,-5.06482e-13,0.138489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.678,6.554L216.623,28.819L224.934,-21.761L-13.553,-18.235L-19.466,207.457L203.906,203.002L185.558,185.995C185.558,185.995 63.169,186.614 19.668,186.834C15.67,186.855 11.829,185.278 8.998,182.453C6.167,179.629 4.581,175.792 4.593,171.793C4.688,137.582 4.919,54.557 5.014,20.397C5.025,16.408 6.625,12.587 9.46,9.78C12.294,6.973 16.13,5.411 20.119,5.439C62.327,5.736 178.678,6.554 178.678,6.554Z",
    style: {
      fill: "rgb(201,231,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.47067,0,0,3.26535,-1048.57,0.138489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.405,
    y: 0,
    width: 374.405,
    height: 373.865,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer4",
    transform: "matrix(1.80318,0,0,1.95609,-332.585,-546.537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.703,466.334L439.36,466.334C431.076,466.334 424.36,459.618 424.36,451.334C424.36,417.051 424.36,333.283 424.36,299C424.36,295.022 425.94,291.206 428.753,288.393C431.566,285.58 435.382,284 439.36,284C473.693,284 557.667,284 592,284C600.284,284 607,290.716 607,299L607,343.952",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer2",
    transform: "matrix(1.80318,0,0,1.95609,-332.585,-546.537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.032,466.334L597.378,466.334C599.93,466.334 602.377,465.32 604.182,463.516C605.986,461.711 607,459.264 607,456.712C607,456.712 607,456.711 607,456.711C607,454.943 606.092,453.299 604.596,452.357C592.238,444.58 536.44,409.464 536.44,409.464L544.736,414.685C544.736,414.685 586.967,415.791 601.869,416.182C603.217,416.217 604.523,415.706 605.489,414.765C606.455,413.824 607,412.532 607,411.183C607,405.536 607,397.249 607,397.249C607,397.249 616.41,386.091 620.782,380.907C622.042,379.412 622.037,377.226 620.77,375.736C616.394,370.592 607,359.551 607,359.551L607,319.759",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 10
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.714912,0,0,0.715573,155.225,82.385)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 547.608,
    cy: 340.775,
    r: 11.128,
    style: {
      stroke: "black",
      strokeWidth: "11.51px"
    }
  }))))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsericonColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/usericon_color.7710b8c4.svg";
export { ForwardRef as ReactComponent };